export default "/images/vendor/flag-icon-css/flags/1x1/ms.svg?dd5003c60480d12f3c6778fb4d5fc26c";